import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/Core/services/backend.service';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-loan-info-card',
  templateUrl: './loan-card-info.component.html',
  styleUrls: ['./loan-card-info.component.scss'],
})
export class LoanInfoCardComponent {
  @Input() offer: any;

  constructor(private backend: BackendService, private toast: ToastService) {}
  ngOnInit(): void {}
}
